module.exports = __webpack_public_path__ + "img/SC-PROOF-7799.b9602164.png";